
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <a-select
                      showSearch
                      optionFilterProp="title"
                      v-model="queryParam.clubleixing"
                      placeholder="类型"
                      allowClear
              >
                <a-select-option   title="考级中心" value="学校俱乐部">学校俱乐部</a-select-option>
                <a-select-option   title="社会俱乐部" value="社会俱乐部">社会俱乐部</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="所属地区">
              <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="queryParam.namekeys" changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报状态">
              <a-select v-model="queryParam.registstatus" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
                <a-select-option value="4">预审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="多单位查询">
                <a-textarea
                  v-model="queryParam.danweis"
                  placeholder="请输入单位名称多条换行"
                />
              </a-form-item>
            </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="负责人姓名">
                <a-input v-model="queryParam.nickname" placeholder="搜索负责人姓名"/>
              </a-form-item>
            </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="联系电话">
              <a-input v-model="queryParam.phone" placeholder="联系电话"/>
            </a-form-item>
          </a-col>

         <a-col :md="6" :sm="24">
           <a-form-item label="申报进度">
             <a-select v-model="queryParam.jindu" placeholder="请选择"
                       allowClear >
               <a-select-option :key="0" value="0">无</a-select-option> 
               <a-select-option :key="6" value="6">授牌</a-select-option> 
             </a-select>
           </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="申报时间">
              <a-range-picker
                      v-model="time_range_moment"
                      style="width: 100%"
                      format="YYYY-MM-DD HH:mm:ss"
                      :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
              />
            </a-form-item>
          </a-col>
 </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >
      <a-button @click="download(2)" style="margin-left: 8px">
      下载信息表
      <a-icon type="download" />
      </a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <!--          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>--> 
          <a-menu-item @click="onShoupaiAll(6)" key="3">
             授牌
          </a-menu-item>
          <a-menu-item @click="onShoupaiAll(0)" key="4">
             取消授牌
          </a-menu-item>
          <a-menu-item @click="onGradeAll('一星')" key="5">
             设为一星
          </a-menu-item>
          <a-menu-item @click="onGradeAll('二星')" key="5">
             设为二星
          </a-menu-item> 
          <a-menu-item @click="onClubDeleteAll" key="99">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="danwei" slot-scope="text,record">
          <img style="width: 38px ; height: 38px; float: left" :src="record.pic_url" />
          <div style="margin-left: 10px; float: left">
            {{record.danwei}}
            <a-tag v-if="record.clubleixing=='学校俱乐部'" color="green">
              学校俱乐部
            </a-tag>
            <a-tag v-else color="blue">
              社会俱乐部
            </a-tag>

            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            负责人:{{record.nickname}} <span style="color: #999">手机:{{record.phone}}</span>
            <br/>
            联系人:{{record.contactsname}} <span style="color: #999">手机:{{record.contactsphone}}</span>

            <br/>
            等级:
            <a-tag  >{{record.bgrade}}</a-tag>

          </div>
      </span>
      <span slot="code" slot-scope="text,record">
            {{record.bcode?record.bcode:'(无)'}}
            <br/>
            申请时间 {{record.create_time|timeFormat}}
            <br/>
        <span v-if="record.recommend_name" >推荐加盟人：{{record.recommend_name}}</span>

      </span>
      <span slot="jindu" slot-scope="text,record">

        <a-tag v-if="record.registstatus==1" color="red">等待审核</a-tag>
        <a-tag v-else-if="record.registstatus==2" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.registstatus==3" color="purple">审核失败</a-tag>
        <a-tag v-else>未提交</a-tag>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">查看</a><br/>

        </template>
      </span>
    </s-table>



    <a-modal
            title="操作"
            :width="1200"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="所属省市"
                      hasFeedback
              >
                <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.namekeys" changeOnSelect
                />
              </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="类型"
                        hasFeedback
                >

                  <a-select v-model="formData.clubleixing" placeholder="请选择"
                             >
                    <a-select-option value="学校俱乐部">学校俱乐部</a-select-option>
                    <a-select-option value="社会俱乐部">社会俱乐部</a-select-option>
                  </a-select>
                </a-form-item>
                </a-col>
              </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="等级"
                      hasFeedback
              >
                <a-select v-model="formData.bgrade" placeholder="请选择"
                >
                  <a-select-option value="一星">一星</a-select-option>
                  <a-select-option value="二星">二星</a-select-option>
                  <a-select-option value="三星">三星</a-select-option>
                  <a-select-option value="四星">四星</a-select-option>
                  <a-select-option value="五星">五星</a-select-option>
                </a-select>
              </a-form-item>
              </a-col>
              <a-col :md="12" :sm="24">
                <a-form-item
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                        label="申报单位"
                        hasFeedback
                >

                  <a-input  v-decorator="[
          'shenbaodanwei',
          {rules: [{ required: true, message: '请输入申报单位' }]}
        ]"
                            placeholder="请输入申报单位"/>
                </a-form-item>
                </a-col>
              </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="俱乐部名称"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'danwei',
          {rules: [{ required: true, message: '请输入俱乐部名称' }]}
        ]"
                     placeholder="请输入单位"/>
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="授权编号"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'bcode',
          {rules: []}
        ]"
                     placeholder="请输入授权编号"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="场地面积"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'chandimianji',
          {rules: [{ required: true, message: '请输入场地面积' }]}
        ]"
                     placeholder="请输入场地面积"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="拟注册运动员人数"
                  hasFeedback
          >
            <a-input type="number"  v-decorator="[
          'yundongyuanrenshu',
          {rules: [{ required: true, message: '请输入拟注册运动员人数' }]}
        ]"
                     placeholder="请输入拟注册运动员人数"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单位地址"
                  hasFeedback
          >
            <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
            />
          </a-form-item>
              </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="详细地址"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'address',
          {rules: [{ required: true, message: '请输入详细地址' }]}
        ]"
                      placeholder="请输入详细地址"/>
          </a-form-item>
            </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="场地照片"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.changdipic"
            />
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="申报表"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.shenbaozip"
            />
          </a-form-item>
              </a-col>
            </a-row>
          <a-divider>负责人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'nickname',
          {rules: [{ required: true, message: '请输入负责人姓名' }]}
        ]"
                      placeholder="请输入负责人姓名"/>
          </a-form-item>

            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人身份证号"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'certificatenumber',
          {rules: [{ required: true, message: '请输入负责人身份证号' }]}
        ]"
                      placeholder="请输入负责人身份证号"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人邮箱"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'email',
          {rules: [{ required: true, message: '请输入负责人邮箱' }]}
        ]"
                      placeholder="请输入负责人邮箱"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人手机"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入负责人手机' }]}
        ]"
                      placeholder="请输入负责人手机"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48"
                 v-if="false">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人QQ"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'qq',
          {rules: [{ required: true, message: '请输入负责人QQ' }]}
        ]"
                      placeholder="请输入负责人QQ"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="负责人微信"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'weixin',
          {rules: [{ required: true, message: '请输入负责人微信' }]}
        ]"
                      placeholder="请输入负责人微信"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-divider>联系人信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人姓名"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsname',
          {rules: [{ required: true, message: '请输入联系人姓名' }]}
        ]"
                      placeholder="请输入联系人姓名"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人身份证"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactscertificatenumber',
          {rules: [{ required: true, message: '请输入联系人身份证' }]}
        ]"
                      placeholder="请输入联系人身份证"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人邮箱"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsemail',
          {rules: [{ required: true, message: '请输入联系人邮箱' }]}
        ]"
                      placeholder="请输入联系人邮箱"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人手机"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsphone',
          {rules: [{ required: true, message: '请输入联系人手机' }]}
        ]"
                      placeholder="请输入联系人手机"/>
          </a-form-item>
              </a-col>
            </a-row>
          <a-row :gutter="48"
                 v-if="false">
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人QQ"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsqq',
          {rules: [{ required: true, message: '请输入联系人QQ' }]}
        ]"
                      placeholder="请输入联系人QQ"/>
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="联系人微信"
                  hasFeedback
          >
            <a-input  v-decorator="[
          'contactsweixin',
          {rules: [{ required: true, message: '请输入联系人微信' }]}
        ]"
                      placeholder="请输入联系人微信"/>
          </a-form-item>
              </a-col>
            </a-row>

          <a-divider>审核信息</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
          <a-form-item
                  label="验收图片证明"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <pic-uploader
                    :file-list="formData.yanshou_pic"
            />
          </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="验收表上传"
                      hasFeedback
              >
                <pic-uploader
                        :file-list="formData.yanshoubiao_pic"
                />
              </a-form-item>
            </a-col>
            </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="备案审核"
                  hasFeedback
          >
            <a-radio-group v-model="formData.registstatus" buttonStyle="solid">
              <a-radio-button :value="0">未提交</a-radio-button>
              <a-radio-button :value="1">待审核</a-radio-button>
              <a-radio-button :value="2">审核通过</a-radio-button>
              <a-radio-button :value="3">审核失败</a-radio-button>
            </a-radio-group>
          </a-form-item>
              </a-col>
            </a-row>



          <a-row :gutter="48" v-if="false">
            <a-col :md="48" :sm="24">
              <a-form-item
                      :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                      :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                      label="支付状态"
                      hasFeedback
              >
                  <a-radio-group v-model="formData.is_pay" button-style="solid">
                    <a-radio-button :value="2">
                      未支付
                    </a-radio-button>
                    <a-radio-button :value="1">
                      已支付
                    </a-radio-button>
                  </a-radio-group>

              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="拒绝审核理由"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'registstatusdes',
          {rules: []}
        ]"
                        placeholder="请拒绝审核理由"/>
          </a-form-item>
</a-col>
            <a-col :md="48" :sm="24">
          <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="管理员备注"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'clubadminnote',
          {rules: []}
        ]"
                        placeholder="管理员备注"/>
          </a-form-item>
</a-col>
            </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
<!--        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>-->
      </template>
    </a-modal>



  </a-card>
  </template>

  <script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import { getClubList ,getClubDetail,editClub,getClubDownloadUrl,
  setShoupaiAll,
  setGradeAll,
   } from '@/api/club'
  export default {
    name: 'ExameCenterList',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      RSwitch,
      EditableCell,
    },
    data () {
      return {
        areaOptions,
        visible: false,
        saveLoading:false,
        formData:{
          id:0,
          danwei:'',
          changdipic:[],
          namekeys:[],
          areas:[],
          zhizhaopic:[],
          shenbaozip:[],
          yanshou_pic:[],
          yanshoubiao_pic:[],
          xflag:[],
          is_tequan:2,
        },
        buyGoodsOptions:[
          {
            "label":"1 标准肋木",
            "value":1
          },
          {
            "label":"2 标准把杆（固定/移动）",
            "value":2
          },
          {
            "label":"3 斜坡啦啦操垫（翻滚）",
            "value":4
          },
          {
            "label":"4 啦啦操训练垫",
            "value":8
          },
          {
            "label":"5 柔韧测试器（髋部）",
            "value":16
          },
          {
            "label":"6 积木式跳箱",
            "value":32
          },
          {
            "label":"7 柔韧测试器（肩部）",
            "value":64
          },
          {
            "label":"8 啦啦操翻腾训练辅助器（组合）A",
            "value":128
          },
          {
            "label":"9 啦啦操翻腾训练辅助器（组合）B",
            "value":256
          },
          {
            "label":"10 七彩星级专用训练考试地胶",
            "value":512
          },
          {
            "label":"11 啦啦操方形蹦床",
            "value":1024
          },
          {
            "label":"12啦啦操专用平衡器",
            "value":2048
          }
        ],
        time_range_moment:[],
        time_range:[],
        labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
          xs: { span: 24 },
          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '单位信息',
            dataIndex: 'danwei',
            scopedSlots: { customRender: 'danwei' },
          },
          {
            title: '授权编号',
            dataIndex: 'code',
            scopedSlots: { customRender: 'code' },
          },
          {
            title: '进度',
            dataIndex: 'jindu',
            scopedSlots: { customRender: 'jindu' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 100,
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getClubList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
        cashFormData:{
          ids:[],
          to_type:'',
          price:0,
          note:'',
          count:0,
        }
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      handleEdit(record){
        let self = this
        this.visible = true
        getClubDetail({ id: record.id }).then(res => {
          setTimeout(() =>{
            self.form.setFieldsValue({ ...res.data })
            self.formData.id = record.id;
            console.log('handleEdit')
            if(res.data.namekey){
              res.data.namekeys = [res.data.namekey.substring(0,2)+'0000',res.data.namekey.substring(0,4)+'00',res.data.namekey];
            }else{
              res.data.namekeys = [];
            }
            if(res.data.area){
              res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
            }else{
              res.data.areas = [];
            }
            res.data.xflag = res.data.xflag.map(item =>{
              return parseInt(item);
            })
            self.formData = { ...res.data };
          },200)
        })
        // console.log(this.mdl)
      },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            editClub({
              id:self.formData.id,
              namekey:self.formData.namekeys[self.formData.namekeys.length-1],
              clubleixing:self.formData.clubleixing,
              bgrade:self.formData.bgrade,
              danwei:values.danwei,
              shenbaodanwei:values.shenbaodanwei,
              bcode:values.bcode,
              chandimianji:values.chandimianji,
              yundongyuanrenshu:values.yundongyuanrenshu,
              area:self.formData.areas[self.formData.areas.length-1],
              address:values.address,
              changdipic:self.formData.changdipic,
              shenbaozip:self.formData.shenbaozip,
              nickname:values.nickname,
              certificatenumber:values.certificatenumber,
              email:values.email,
              phone:values.phone,
              qq:values.qq,
              weixin:values.weixin,
              contactsname:values.contactsname,
              contactscertificatenumber:values.contactscertificatenumber,
              contactsemail:values.contactsemail,
              contactsphone:values.contactsphone,
              contactsqq:values.contactsqq,
              contactsweixin:values.contactsweixin,
              yanshou_pic:self.formData.yanshou_pic,
              registstatus:self.formData.registstatus,
              yanshoubiao_pic:self.formData.yanshoubiao_pic,
              registstatusdes:values.registstatusdes,
              clubadminnote:values.clubadminnote,
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }
        })
      },
    onShoupaiAll(status){
      let self = this;
      setShoupaiAll({ ids: this.selectedRowKeys ,'status':status })
        .then((res) => {
          self.$message.success("设置成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    onGradeAll(grade){
      let self = this;
      setGradeAll({ ids: this.selectedRowKeys ,'grade':grade })
        .then((res) => {
          self.$message.success("设置成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

      download(type){
        let params = Object.assign(this.queryParam, { time_range: this.time_range_moment, type: type })
        // console.log('params', params);return
        getClubDownloadUrl(params)
            .then(res => {
              console.log(res)
              window.open(res.data)
            })
            .catch(err => {
              this.$message.error(err.data.msg)
            })
      },
    onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },

    },
    filters:{
      jinduFilter(value){
        switch (value){
          case 1:
            return `联系申报单位`;
          case 2:
            return `告知省级省市并征求意见+申报单位积极准备中`;
          case 3:
            return `申报单位积极准备中`;
          case 4:
            return `条件已具备，等待验收`;
          case 5:
            return `等待全国啦啦操省市验收`;
          case 6:
            return `验收并授牌`;
          case 7:
            return `同意考试`;
        }
      },
    },
    watch: {
    }
  }
</script>
